module.exports = __webpack_public_path__ + "img/logo-educacentre.561d5b2b.jpg";